export default __webpack_public_path__ + "static/media/payment-pending-light.e12dd56b.png";